// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../src-custom-solutions/president-election/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../src-custom-solutions/president-election/node_modules/css-loader/dist/cjs.js??ref--9-oneOf-1-1!../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../src-custom-solutions/president-election/node_modules/postcss-loader/src/index.js??ref--9-oneOf-1-2!../../../../src-custom-solutions/president-election/node_modules/postcss-loader/src/index.js??ref--9-oneOf-1-3!../../../../node_modules/simplebar/dist/simplebar.min.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, "", ""]);
// Exports
module.exports = exports;
